import { config } from 'settings/custom/module'
import { log } from 'utils/Logger'

let storage = null

function init() {
  storage = config
}

function getConfig(key) {
  if (!storage.hasOwnProperty(key)) {
    log(`Cannot find key '${key}' in text config`)
    return null
  }
  return storage[key]
}

export const ModuleSettingsService = {
  init,
  getConfig,
}
